module.exports = __webpack_public_path__ + "img/bottom-shape.f1b82c35.png";